import axios from "axios";
import { env } from "../../env";
import { RPC_TERMS_ENDPOINTS } from "../endpoints";

const BASE_URL = env.REACT_APP_CLIENT_API_URL || "";

const STORAGE_KEY_PREFIX = "terms_";

export const getTermsStorageKey = (language) => `${STORAGE_KEY_PREFIX}${language}`;

export const getTermsAndConditions = async (language = "en") => {
    const response = await axios.post(
        `${BASE_URL}${RPC_TERMS_ENDPOINTS.GET_TERMS}`,
        { _language: language },
        { headers: { "Content-Type": "application/json" } }
    );
    const data = response?.data;
    return {
        language: data?.Language || language,
        terms: data?.Terms || "",
    };
};

export const fetchAndCacheTerms = async (language = "en") => {
    const result = await getTermsAndConditions(language);
    if (result.terms) {
        sessionStorage.setItem(getTermsStorageKey(language), result.terms);
    }
    return result;
};

export const getCachedTerms = (language = "en") => {
    return sessionStorage.getItem(getTermsStorageKey(language)) || "";
};
